import { render, staticRenderFns } from "./AddAdditionalCompetencyModal.vue?vue&type=template&id=29c9b338&scoped=true&"
import script from "./AddAdditionalCompetencyModal.vue?vue&type=script&lang=js&"
export * from "./AddAdditionalCompetencyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c9b338",
  null
  
)

export default component.exports